import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import { setupNavMenus } from "./nav_menus.js"
import { setupChatDemo } from "./chat_demo.js"
import { setupFloatCta } from "./float_cta.js"
import { setupTemplateGate } from "./template_gate.js"

setupNavMenus()
setupChatDemo()
setupFloatCta()
setupTemplateGate()
